import { render, staticRenderFns } from "./AnnouncementEditor.vue?vue&type=template&id=7863848e&scoped=true&"
import script from "./AnnouncementEditor.vue?vue&type=script&lang=js&"
export * from "./AnnouncementEditor.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementEditor.vue?vue&type=style&index=0&id=7863848e&scoped=true&lang=css&"
import style1 from "./AnnouncementEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7863848e",
  null
  
)

export default component.exports